import { withTranslation } from 'react-i18next';

import DataTable from '../../../../components/Datatable';
import { getSortKeys, setAdditionalStyles } from '../../../../helpers/table';
import { SOURCES, sourceLabel } from '../sources';
import { SOURCE_COLUMNS, sourceRows } from '../keys';

/**
 * Block 05 — the three surfaces this report can read, which one it read, and the export of it.
 *
 * All three are listed even though only one is on screen, because the commonest misreading of
 * this report is to take one of them for all of them: "News" is three different products, and a
 * reader who sees only the one they picked has no way to know the other two exist or that they
 * were not counted. The active one is marked; the others are named so their absence is visible.
 *
 * The export is the active source and nothing else — its summary, its daily rows, and the scope
 * they were read under. The page and country tables export themselves from their own buttons, so
 * no file this page produces ever puts two sources side by side.
 */
function SourceCoverage({ t, scope, exportable, onExport }) {
    const columns = SOURCE_COLUMNS(t);
    const rows = sourceRows(t, SOURCES);

    return (
        <div className="card table-main rounded-main overflow-hidden gsc-tool-block">
            <div className="card-header d-flex justify-content-between">
                <div>
                    <p className="card-title">{t('tools.discover_news.coverage.title')}</p>
                    <p className="gsc-tool-sub">{t('tools.discover_news.coverage.description')}</p>
                </div>

                <div className="gsc-tool-icon-actions">
                    <button
                        type="button"
                        title={t('tools.discover_news.coverage.export', {
                            source: sourceLabel(t, scope.searchType),
                        })}
                        aria-label={t('tools.discover_news.coverage.export', {
                            source: sourceLabel(t, scope.searchType),
                        })}
                        onClick={onExport}
                        disabled={!exportable}
                    >
                        <i className="icon-fi_download" />
                    </button>
                </div>
            </div>

            <div className="card-body">
                <DataTable
                    nodes={rows}
                    COLUMNS={columns}
                    sortFns={getSortKeys(columns)}
                    additionalStyles={setAdditionalStyles(columns)}
                    onlyTable
                    notUseDefaultStyle
                    customContainerStyles="gsc-tool-rules-table"
                    rowClassName={(item) => (item.type === scope.searchType ? 'dt-row-picked' : '')}
                />

                <p className="gsc-tool-table-note">
                    {t('tools.discover_news.coverage.active', {
                        source: sourceLabel(t, scope.searchType),
                    })}
                </p>
                <p className="gsc-tool-table-note">
                    {t('tools.discover_news.coverage.never_merged')}
                </p>
                <p className="gsc-tool-table-note">
                    {t('tools.discover_news.coverage.export_note')}
                </p>
                <p className="gsc-tool-table-note">
                    {t('tools.discover_news.coverage.no_storage')}
                </p>
            </div>
        </div>
    );
}

export default withTranslation()(SourceCoverage);
